<template>
  <div class="content-page">
    <div class="bd" v-show="!isShowSort">
      <div class="tab-header">
        <el-button
          type="primary"
          size="small"
          @click="createTag"
          v-if="shopIsMaster"
          >新建分类</el-button
        >
        <el-button
          type="primary"
          size="small"
          plain
          @click="tagShort"
          v-if="shopIsMaster"
          >分类排序</el-button
        >
        <el-button type="primary" size="small" @click="exportGoodsCategory"
          >导出商品分类</el-button
        >
        <el-upload
          class="upload-xls"
          action="/edcmanageapi/Goods_importGoodsNum"
          :http-request="uploadXls"
          :show-file-list="false"
          v-if="shopIsMaster"
        >
          <el-button type="primary" size="small">批量上传商品分类</el-button>
        </el-upload>
        <el-link
          type="primary"
          class="fix-middle"
          :underline="false"
          :href="xlsLink"
        >
          <i class="iconfont iconxiazai-copy"></i>下载商品分类模板
        </el-link>
      </div>
      <div class="tab-content">
        <div class="tag-list">
          <el-table :data="tagList" style="width: 100%;">
            <el-table-column
              label="分类名称"
              width="100"
              :show-overflow-tooltip="true"
              prop="categoryName"
            >
              <!-- <template slot-scope="scope">
                <div class="tag-name">{{ scope.row.categoryName }}</div>
              </template> -->
            </el-table-column>
            <el-table-column label="图片" align="center">
              <template slot-scope="scope">
                <el-image
                  v-if="scope.row.categoryImage"
                  style="width: 50px; height: 50px"
                  :src="scope.row.categoryImage"
                  :preview-src-list="scope.row.preSrcList"
                ></el-image>
              </template>
            </el-table-column>
            <el-table-column label="包含商品">
              <template slot-scope="scope">
                <div class="item-count">{{ scope.row.goodsTypes }}</div>
              </template>
            </el-table-column>
            <el-table-column label="分类编号（用于批量上传）">
              <template slot-scope="scope">
                <div class="item-count">{{ scope.row.otherNumber }}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              header-align="right"
              v-if="shopIsMaster"
            >
              <template slot-scope="scope">
                <div class="float-right">
                  <el-button
                    size="small"
                    type="primary"
                    @click="edit(scope.$index)"
                    plain
                    >编辑</el-button
                  >
                  <el-button size="small" plain @click="del(scope.$index)"
                    >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="pageNo"
            background
            layout="prev, pager, next, jumper"
            :total="totalPage"
          ></el-pagination>
        </div>
      </div>
    </div>
    <div class="bd sort" v-show="isShowSort">
      <div class="tab-header">
        <el-button type="primary" size="small" @click="saveSort"
          >保存排序</el-button
        >
        <el-button type="primary" plain size="small" @click="cancelSort"
          >取消</el-button
        >
        <span class="sort-tips">鼠标拖拽进行排序</span>
      </div>
      <div class="tab-content">
        <div class="list-header">
          <div>分类名称</div>
          <div>包含商品</div>
          <div>分类编号（用于批量上传）</div>
          <div>操作</div>
        </div>
        <div class="tag-list">
          <div
            class="tag-item"
            v-for="(item, index) in tagList"
            :key="item.goodsCategoryId"
            v-dragging="{ item: item, list: tagList }"
          >
            <div class="tag-name">{{ item.categoryName }}</div>
            <div class="item-count">{{ item.goodsTypes }}</div>
            <div class="item-count">{{ item.otherNumber }}</div>
            <div class="action">
              <el-button
                size="small"
                type="primary"
                plain
                @click="moveToTop(index)"
                >移到顶部</el-button
              >
              <el-button
                size="small"
                type="primary"
                plain
                @click="moveToBottom(index)"
                >移到底部</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="addTagVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="resetForm"
      width="536px"
    >
      <div slot="title" class="dialog-title">
        {{ addTagForm.goodsCategoryId ? "编辑分类" : "新建分类" }}
      </div>
      <el-form
        :model="addTagForm"
        :rules="addTagFormRule"
        ref="addTagForm"
        label-width="68px"
        class="demo-ruleForm"
        :hide-required-asterisk="true"
      >
        <el-form-item label="分类图片" prop="categoryImage">
          <el-upload
            action="/ImageServer/YmUpload_image"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="
              (e) => {
                handleRemove(e);
              }
            "
            :http-request="
              (e) => {
                handleSuccess(e);
              }
            "
            :before-upload="beforeImgUpload"
            :file-list="categoryImage"
            :on-exceed="limitTip"
            :limit="1"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </el-form-item>
        <el-form-item label="分类名称" prop="categoryName">
          <el-input
            v-model="addTagForm.categoryName"
            placeholder="请输入分类名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="分类编号" prop="otherNumber">
          <el-input
            v-model="addTagForm.otherNumber"
            type="number"
            placeholder="请输入分类编号（用于批量上传商品）"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动分类" prop="categoryType">
          <el-radio-group v-model="addTagForm.categoryType">
            <el-radio :label="2">是</el-radio>
            <el-radio :label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addTag" :loading="isSubmit">{{
          addTagForm.goodsCategoryId ? "确认" : "添加"
        }}</el-button>
        <el-button @click="addTagVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getEdcShopGoodsCategorys,
  updateEdcGoodsCategory,
  updateEdcGoodsCategoryDel,
  batchUpdateGoodsCategorys,
  importGoodsCategory,
  uploadImg,
} from "@/api";
import request from "@/utils/request";
import { commonFuc } from "@/mixins/commonFuc";
export default {
  mixins: [commonFuc],
  data() {
    return {
      xlsLink: `${request.baseUrl}/download/导入商品分类模板.xls`,
      tagList: [],
      addTagVisible: false,
      addTagForm: {
        categoryName: "",
        categoryImage: "",
        goodsCategoryId: "",
        indexNo: 0,
        otherNumber: "",
        categoryType: 1,
      },
      addTagFormRule: {
        categoryName: [
          {
            required: true,
            message: "请输入分类名称",
            trigger: "blur",
          },
        ],
        categoryImage: [
          {
            required: true,
            message: "请至少上传一张图片",
            trigger: "blur",
          },
        ],
        otherNumber: [
          {
            required: true,
            message: "请输入分类编号（用于批量上传商品）",
            trigger: "blur",
          },
        ],
      },
      categoryImage: [],
      isShowSort: false,
      totalPage: 0,
      pageSize: 5,
      pageNo: 1,
      isSubmit: false,
      dialogImageUrl: "",
      dialogVisible: false,
    };
  },
  mounted() {
    this.$dragging.$on("dragged", ({ value }) => {});
    this.getPageData();
  },
  methods: {
    getPageData() {
      this.getEdcShopGoodsCategorys();
      this.getCategorysNum();
    },
    getEdcShopGoodsCategorys() {
      getEdcShopGoodsCategorys({
        pageNo: this.pageNo,
        row: this.pageSize,
      }).then((res) => {
        if (res.code == 1) {
          res.data.forEach((val) => {
            val.preSrcList = [val.categoryImage];
          });
          this.tagList = res.data;
        } else {
          this.tagList = [];
        }
      });
    },
    getCategorysNum() {
      getEdcShopGoodsCategorys({
        pageNo: this.pageNo,
        row: 1000,
      }).then((res) => {
        if (res.code == 1) {
          this.totalPage = res.data.length;
          if (this.pageNo > this.totalPage / this.pageSize) {
            this.pageNo = Math.ceil(this.totalPage / this.pageSize);
            this.getEdcShopGoodsCategorys();
          }
        }
      });
    },
    moveToTop(index) {
      let list = this.tagList;
      list.unshift(...list.splice(index, 1));
    },
    moveToBottom(index) {
      let list = this.tagList;
      list.push(...list.splice(index, 1));
    },
    tagShort() {
      this.pageNo = 1;
      this.pageSize = 1000;
      this.getEdcShopGoodsCategorys();
      this.isShowSort = true;
    },
    saveSort() {
      let list = JSON.parse(JSON.stringify(this.tagList));
      let goodsCategoryIndexNoJson = [];
      list.reverse();
      list.forEach((val, index) => {
        goodsCategoryIndexNoJson.push({
          goodsCategoryId: val.goodsCategoryId,
          indexNo: index,
        });
      });
      batchUpdateGoodsCategorys({
        bachMethod: "I",
        goodsCategoryIndexNoJson: JSON.stringify(goodsCategoryIndexNoJson),
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "修改成功",
            type: "success",
            duration: 2000,
          });
          this.pageSize = 5;
          this.isShowSort = false;
          this.getEdcShopGoodsCategorys();
        }
      });
    },
    cancelSort() {
      this.pageSize = 5;
      this.getPageData();
      this.isShowSort = false;
    },
    handleSizeChange() {},
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getEdcShopGoodsCategorys();
    },
    uploadXls(item) {
      if (!~item.file.name.indexOf(".xls")) {
        this.$notify({
          title: "警告",
          message: "请上传xls格式文件",
          type: "warning",
          duration: 2000,
        });
        return;
      }
      let sessionId = localStorage.getItem("sessionId");
      let userId = localStorage.getItem("userId");
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", item.file);
      imgUploadForm.append("userId", userId);
      imgUploadForm.append("sessionId", sessionId);
      importGoodsCategory(imgUploadForm).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "导入成功",
            type: "success",
            duration: 2000,
          });
          this.getPageData();
        }
        if (res.code == 0) {
          this.$notify({
            title: "警告",
            message: res.msg,
            type: "warning",
            duration: 2000,
          });
        }
      });
    },
    createTag() {
      this.addTagVisible = true;
    },
    addTag() {
      this.$refs.addTagForm.validate((valid) => {
        if (valid) {
          this.isSubmit = true;
          updateEdcGoodsCategory(this.addTagForm).then((res) => {
            if (res.code == 1) {
              this.$notify({
                title: "提示",
                message: this.addTagForm.goodsCategoryId
                  ? "修改成功"
                  : "添加成功",
                type: "success",
                duration: 2000,
              });
              this.addTagVisible = false;
              this.getPageData();
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "error",
                duration: 2000,
              });
            }
            this.isSubmit = false;
          });
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    edit(index) {
      this.addTagForm = Object.assign({}, this.addTagForm, this.tagList[index]);
      this.categoryImage = this.addTagForm.categoryImage
        ? [{ url: this.addTagForm.categoryImage }]
        : [];
      this.createTag();
    },
    del(index) {
      this.$msgbox({
        title: "消息",
        message: `是否删除，删除后将无法恢复！`,
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            updateEdcGoodsCategoryDel({
              goodsCategoryId: this.tagList[index].goodsCategoryId,
            }).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "删除成功",
                  type: "success",
                  duration: 2000,
                });
                this.getPageData();
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "error",
                  duration: 2000,
                });
              }
            });
            done();
          } else {
            done();
          }
        },
      }).then((action) => {});
    },
    resetForm() {
      this.addTagForm = {
        categoryName: "",
        categoryImage: "",
        goodsCategoryId: "",
        indexNo: 0,
        otherNumber: "",
        categoryType: 1,
      };
      this.categoryImage = [];
      this.$refs.addTagForm.resetFields();
    },
    handleRemove(file) {
      this.addTagForm.categoryImage = "";
    },
    beforeRemove(file, fileList) {},
    limitTip(files, fileList) {
      this.$notify({
        title: "警告",
        message: "只能上传一张图片，请删除图片后再上传",
        type: "warning",
        duration: 6000,
      });
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    beforeImgUpload(file) {
      const isLt3M = file.size / 1024 / 1024 < 3;
      if (!isLt3M) {
        this.$notify.error("上传图片大小不能超过 3MB!");
      }
      return isLt3M;
    },
    handleSuccess(item) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", item.file);
      imgUploadForm.append("fileContentType", item.file.type);
      imgUploadForm.append("fileFileName", item.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      uploadImg(imgUploadForm).then((res) => {
        if (res.code == 1) {
          this.addTagForm.categoryImage = res.data.url;
          console.log(this.addTagForm);
        }
      });
    },
    exportGoodsCategory() {
      location.href = `${
        request.baseUrl
      }/edcmanageapi/Goods_exportGoodsCategory?userId=${
        localStorage.userId
      }&sessionId=${localStorage.sessionId}`;
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .bd {
    &.sort {
      .tab-header {
        background: #fffcf5;
        border-bottom-color: #f2e7b8;
        .sort-tips {
          display: inline-block;
          font-size: 12px;
          color: #555;
          line-height: 17px;
          margin-left: 20px;
        }
      }
      .tab-content {
        display: block;
        padding: 0 20px;
        .list-header {
          display: flex;
          height: 48px;
          line-height: 48px;
          justify-content: space-between;
          border-bottom: 1px solid #ebeef5;
          box-sizing: border-box;
          font-size: 0;
          div {
            flex: 1;
            font-size: 14px;
            color: rgb(144, 147, 153);
            padding: 0 10px;
            font-weight: bold;
            &:last-of-type {
              text-align: right;
            }
          }
        }
        .tag-list {
          padding: 0;
          .tag-item {
            display: flex;
            justify-content: space-between;
            height: 57px;
            line-height: 56px;
            font-size: 0;
            border-bottom: 1px solid #ebeef5;
            box-sizing: border-box;
            div {
              flex: 1;
              font-size: 14px;
              color: rgb(96, 98, 102);
              padding: 0 10px;
              &:last-of-type {
                text-align: right;
              }
            }
          }
        }
      }
    }
  }
  .tab-header {
    .upload-xls {
      display: inline-block;
      margin: 0 15px;
    }
    .el-button + .el-link {
      margin-left: 10px;
    }
  }
  .tag-list {
    width: 100%;
    padding: 0 20px;
  }
}
</style>
